<template>
  <gj-modal
      :visible.sync="modalVisible"
      global
      type="picture">
    <template #content>
      <div @click="enjoyErp">
        <img src="./image/gift_2x.png" class="gift-img--2x" />
        <img src="./image/gift.png" class="gift-img" />
        <div @click.stop.prevent="cancel">
          <img src="./image/close_2x.png" class="close-icon--2x" />
          <img src="./image/close.png" class="close-icon" />
        </div>
      </div>
    </template>
  </gj-modal>
</template>

<script>
  import {modalMixIn} from "../../../../../minxins";

  export default {
    name: "app-gift-package-modal",
    mixins: [modalMixIn],
    methods: {
      enjoyErp() {
        this.$router.push('/system/market');
        this.$gjDestroy();
      }
    }
  }
</script>

<style scoped>
  @media (max-width: 1366px) {
    .gift-img--2x,
    .close-icon--2x {
      display: none;
    }
  }
  @media (min-width: 1367px) {
    .gift-img,
    .close-icon {
      display: none;
    }
  }
  
  .close-icon--2x,
  .close-icon,
  .gift-img--2x,
  .gift-img {
    cursor: pointer;
  }
  .close-icon {
    position: absolute;
    top: -4px;
    right: -4px;
  }
  .close-icon--2x {
    position: absolute;
    height: 40px;
    top: -8px;
    right: -8px;;
  }
  .gift-img--2x {
    height: 600px;
  }
</style>



